<div class="container">
    <div class="row">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Adventskalender</mat-card-title>
                </mat-card-header>
                <mat-card-content style="display: flex;">
                    <div class="example-container">
                        <h4>Zugeordnete Aktionen:</h4>

                        <div cdkDropList #activeAdvent="cdkDropList" [cdkDropListData]="inUseEvents_Advent "
                            [cdkDropListConnectedTo]="[inactiveAdvent]" class="example-list"
                            (cdkDropListDropped)="drop($event)">
                            <div class="example-box" *ngFor="let item of inUseEvents_Advent " cdkDrag
                                (cdkDragStarted)="handleDragStart($event)" (click)="deltefromListAdvents($event,item)">
                                {{item.NUMBER +1 }}    {{item.title }}
                            </div>
                        </div>
                    </div>

                    <div class="example-container">
                        <h4>Verfügbare Aktionen:</h4>

                        <div cdkDropList #inactiveAdvent="cdkDropList" [cdkDropListData]="avalibleEvents_Advent "
                            [cdkDropListConnectedTo]="[activeAdvent]" class="example-list"
                            (cdkDropListDropped)="drop($event)">
                            <div class="example-box" *ngFor="let item of avalibleEvents_Advent " cdkDrag
                                (cdkDragStarted)="handleDragStart($event)" (click)="addToListAdvents($event,item)">
                                {{item.title}}
                            </div>
                        </div>
                    </div>

                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="primary" (click)="updateAdventTiles()">
                        Änderungen speichern
                    </button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>
</div>

<div class="container" *ngIf="loading">
    <div class="row">
        <div class="col-sm-12 padding">
            <div class="loadingOverlay">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>
</div>